import React from 'react'

// Lo que sale del club cuando juega un torneo de la red. Desde la pieza 2b (spec 2026-10-11
// §6) no hay casillas: participar exige compartir siempre lo mismo, y el Aviso del club 1.1 y
// el DPA 1.1 lo declaran. Este texto tiene que decir lo mismo que ellos.
export const TEXTO_COMPARTICION_TORNEOS =
  'Al jugar torneos, tu club comparte con la organizadora: nombre, número, categoría, fecha de nacimiento, CURP y foto de cada jugador, y nombre y foto del cuerpo técnico.'

export default function ComparticionDatos() {
  return (
    <div className="bg-background rounded-xl border p-6 flex flex-col gap-3">
      <div className="text-foreground font-semibold text-lg">Datos que se comparten en torneos</div>
      <p className="text-sm text-foreground">{TEXTO_COMPARTICION_TORNEOS}</p>
      <p className="text-xs text-muted-foreground">
        La organizadora los usa solo para verificar la identidad y la elegibilidad de cada jugador,
        no para difundirlos. Los demás clubes del torneo ven el nombre y el número de tus jugadores. El
        rival de cada partido ve además su foto y la del cuerpo técnico, desde dos días antes del partido
        hasta el final de ese día.
      </p>
      <p className="rounded-md bg-muted/50 px-3 py-2 text-xs text-muted-foreground">
        Nunca salen: teléfonos, correos, contactos de emergencia, datos de pago ni otros documentos.
        Así lo dicen el Aviso de Privacidad de tu club y el convenio con MYKLUBB (DPA).
      </p>
    </div>
  )
}
